import { useState } from 'react'

export function useDropZone(onFile: (file: File) => void) {
  return useMultiDropZone((files) => onFile(files[0]))
}

export function useMultiDropZone(onFiles: (files: File[]) => void) {
  const [isDragOver, setIsDragOver] = useState(false)
  const handlers = {
    onDragOver: (e: React.DragEvent) => {
      e.preventDefault()
      setIsDragOver(true)
    },
    onDragLeave: () => setIsDragOver(false),
    onDrop: (e: React.DragEvent) => {
      e.preventDefault()
      setIsDragOver(false)
      const files = Array.from(e.dataTransfer.files ?? [])
      if (files.length > 0) onFiles(files)
    },
  }
  return { isDragOver, handlers }
}
